import PropTypes from "prop-types";
import { Box, Paper, Typography } from "@mui/material";
import { useParams } from "react-router-dom";

import ChannelPartnerDashboardLayout from "./ChannelPartnerDashboardLayout";
import ChannelPartnerCounsellorsPage from "./ChannelPartnerCounsellorsPage";
import ChannelPartnerCommunityPartnersPage from "./ChannelPartnerCommunityPartnersPage";
import ChannelPartnerSkillProvidersPage from "./ChannelPartnerSkillProvidersPage";
import ChannelPartnerStudentsPage from "./ChannelPartnerStudentsPage";
import ChannelPartnerEarningsPage from "./ChannelPartnerEarningsPage";

const sectionLabels = {
  counsellors: "Counsellors",
  "skill-providers": "Skill Providers",
  "community-partners": "Community Partners",
  earnings: "Earnings",
};

const ComingSoonSection = ({ title }) => (
  <ChannelPartnerDashboardLayout>
    <Box>
      <Typography sx={{ fontSize: 21, fontWeight: 700, color: "#171725", mb: 1.4 }}>{title}</Typography>
      <Paper elevation={0} sx={{ borderRadius: "8px", bgcolor: "#fff", border: "1px solid #EFEFF4", p: 3 }}>
        <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#171725" }}>{title} module</Typography>
        <Typography sx={{ fontSize: 14, color: "#667085", mt: 1 }}>This section is ready for the next implementation phase.</Typography>
      </Paper>
    </Box>
  </ChannelPartnerDashboardLayout>
);

ComingSoonSection.propTypes = { title: PropTypes.string.isRequired };

const ChannelPartnerPortalPage = () => {
  const { section = "students" } = useParams();
  if (section === "students") return <ChannelPartnerStudentsPage />;
  if (section === "counsellors") return <ChannelPartnerCounsellorsPage />;
  if (section === "skill-providers") return <ChannelPartnerSkillProvidersPage />;
  if (section === "community-partners") return <ChannelPartnerCommunityPartnersPage />;
  if (section === "earnings") return <ChannelPartnerEarningsPage />;
  return <ComingSoonSection title={sectionLabels[section] || "Channel Partner Dashboard"} />;
};

export default ChannelPartnerPortalPage;
